<script>
import liquidPreset from './liquid-preset'

export default {
  name: 'liquidItem',
  components: {
    liquidPreset
  },
  props: {
    liquid: Object
  },
  data: function () {
    return {
      toggleMenu: false
    }
  },
  computed: {
    liquidPresets () {
      return this.liquid.liquidpresets.filter(preset => preset.options.length > 0)
    }
  },
  methods: {
    closeMenu () {
      this.toggleMenu = false
    },
    openMenu () {
      this.toggleMenu = true
    },
    highlight () {
      // just adding the click event adds a highlight to a menu item
    },
    getIconPath (icon) {
      const imagePath = require.context('../assets/icons/', true)
      // eslint-disable-next-line
      return API_URL + imagePath(icon, true)
    }
  }
}
</script>

<template>
<div>
  <span class="md-title">{{liquid.title}}</span>

  <div v-for="(preset, index) in liquidPresets" :key="index">
    <liquidPreset v-bind:preset="preset" v-bind:liquid="liquid"/>
  </div>

</div>
</template>

<style lang="scss" scoped>
  .md-menu {
    width: 300px;
    max-width: 100%;
    display: inline-block;
  }
</style>
